export const capitalizeHeader = (header: string): string => {
  return header
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/^./, (str) => str.toUpperCase());
}
